import AuthenticatedLayout from '../../Layouts/AuthenticatedLayout';
// import DeleteUserForm from './Partials/DeleteUserForm';
import UpdatePasswordForm from './Partials/UpdatePasswordForm';
import UpdateProfileInformationForm from './Partials/UpdateProfileInformationForm';
import { format } from 'date-fns';
import { Head } from '@inertiajs/react';

export default function Edit({ auth, status }) {
    return (
        <AuthenticatedLayout
            user={auth.user}
            header={'Profile'}
        >
            <Head title="Profile" />

            <div className="py-12">
                <div className="h-full min-h-screen max-w-7xl mx-auto sm:px-6 lg:px-8 space-y-6">
                    <div className="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
                    <p className="text-center text-sm text-neutral-950 font-thin">Last Session at: {format(new Date(auth?.user?.last_login), "dd-MM-yyyy hh:mm:ss")}</p>

                        <UpdateProfileInformationForm
                            status={status}
                            className="max-w-xl"
                        />
                    </div>

                    <div className="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
                        <UpdatePasswordForm className="max-w-xl" />
                    </div>

                    {/* <div className="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
                        <DeleteUserForm className="max-w-xl" />
                    </div> */}
                </div>
            </div>
        </AuthenticatedLayout>
    );
}
